// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1MOp6","box":"WorkspacesBox_box__ppg1Z","node":"WorkspacesBox_node__3As6c"};